import { render, staticRenderFns } from "./HealthConversationResultDetail.vue?vue&type=template&id=2f6e6259&scoped=true&lang=pug"
import script from "./HealthConversationResultDetail.vue?vue&type=script&lang=js"
export * from "./HealthConversationResultDetail.vue?vue&type=script&lang=js"
import style0 from "./HealthConversationResultDetail.vue?vue&type=style&index=0&id=2f6e6259&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6e6259",
  null
  
)

export default component.exports